import { makeStyles } from "tss-react/mui"
import { indigo } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(() => ({
  searched: {
    backgroundColor: indigo[50],
    color: indigo.A400
  }
}))
